module.exports = __webpack_public_path__ + "media/components/Application/FormTags/Categories/26-8c60195e2cb1bbd96d5c01d216e9d3e2.png";